import { useEffect, useRef } from 'react';

export default function Toast({ message, type = 'success', onDone }) {
  const ref = useRef();

  useEffect(() => {
    const hideTimer = setTimeout(() => {
      if (ref.current) ref.current.classList.add('out');
    }, 2500);
    const doneTimer = setTimeout(onDone, 2800);
    return () => { clearTimeout(hideTimer); clearTimeout(doneTimer); };
  }, [onDone]);

  return (
    <div ref={ref} className={`toast${type === 'error' ? ' error' : ''}`}>
      {type === 'success' ? '✓' : '✕'} {message}
    </div>
  );
}
